<template>
  <v-card min-height="550">
    <col-skeleton-loader v-if="loading" :clms="4"></col-skeleton-loader>
    <v-toolbar flat width="100%">
      <v-toolbar-title class="text-capitalize title"
        >{{ $t("animal.healthRecordInfo.parasiteControl") }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        v-if="parasiteControl && parasiteControl.length > 0"
        @click="showAddParasiteControlDialog('edit')"
        outlined
        right
        height="50"
        width="241"
        color="primary"
      >
        {{ $t("editCurrentRecord") }}
      </v-btn>
      <v-btn
        @click="showAddParasiteControlDialog('add')"
        right
        class="ml-5"
        height="50"
        width="241"
        color="primary"
        type="submit"
      >
        {{ $t("addNewRecord") }}
      </v-btn>
    </v-toolbar>

    <v-row width="100%" v-if="!loading" class="mt-2">
      <v-col cols="12" md="4">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{ $t("animal.healthRecordInfo.date") }}
                  <v-tooltip top color="black">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>{{ $t("animal.healthRecordInfo.treatmentDateTooltip") }}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  {{
                    parasiteControlData && parasiteControlData.parasiteDate
                      ? formatDate(parasiteControlData.parasiteDate)
                      : $t("notSpecified")
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{ $t("animal.healthRecordInfo.purpose") }}
                  <v-tooltip top color="black" max-width="350" >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>{{ $t('animal.healthRecordInfo.purposeTooltip') }}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  {{
                    parasiteControlData && parasiteControlData.purpose
                      ? parasiteControlData.purpose
                      : $t("notSpecified")
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{ $t("animal.healthRecordInfo.drugName") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>{{ $t('animal.healthRecordInfo.drugNameTooltip') }}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  {{
                    parasiteControlData && parasiteControlData.parasiteDrugName
                      ? parasiteControlData.parasiteDrugName
                      : $t("notSpecified")
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{ $t("animal.healthRecordInfo.dose") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>{{ $t('animal.healthRecordInfo.dooseTooltip') }} </span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  {{
                    parasiteControlData && parasiteControlData.doseRate
                      ? parasiteControlData.doseRate
                      : $t("notSpecified")
                  }}
                  {{
                    parasiteControlData && parasiteControlData.doseRateUnit
                      ? parasiteControlData.doseRateUnit
                      : ""
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{ $t("animal.healthRecordInfo.withdrawalPeriod") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span
                      >{{ $t('animal.healthRecordInfo.withdrawTooltip') }}
                    </span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  {{
                    parasiteControlData &&
                    parasiteControlData.withdrawalPeriod >= 0
                      ? parasiteControlData.withdrawalPeriod
                      : $t("notSpecified")
                  }}
                  {{
                    parasiteControlData &&
                    parasiteControlData.withdrawalPeriodUnit
                      ? parasiteControlData.withdrawalPeriodUnit
                      : ""
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{ $t("animal.healthRecordInfo.routeAdministration") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span
                      >{{ $t('animal.healthRecordInfo.routeOfAdministrationTooltip') }}
                    </span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  {{
                    parasiteControlData &&
                    parasiteControlData.routeOfAdministration
                      ? parasiteControlData.routeOfAdministration
                      : $t("notSpecified")
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" md="12">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{ $t("animal.healthRecordInfo.notes") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>{{ $t("animal.healthRecordInfo.notes") }} </span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  {{
                    parasiteControlData && parasiteControlData.remarks
                      ? parasiteControlData.remarks
                      : $t("notSpecified")
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
    <div class="mt-7">
      <span style="font-size: 20px"> Parasite Control History </span>
      <v-data-table
        class="mt-7"
        :headers="headers"
        :items="parasiteControlTableData"
        :items-per-page="20"
        hide-default-footer
        :loading="loading"
        loading-text="Loading Data..."
      >
        <template #item.parasiteDate="{ item }">{{
          item.parasiteDate ? formatDate(item.parasiteDate) : ""
        }}</template>
        <template #item.doseRate="{ item }"
          >{{ item.doseRate }} {{ item.doseRateUnit || "" }}</template
        >
        <template #item.withdrawalPeriod="{ item }"
          >{{ item.withdrawalPeriod }}
          {{ item.withdrawalPeriodUnit || "" }}</template
        >
        <template v-slot:item.actions="{ item }">
          <div class="d-flex">
            <v-icon class="mr-2" @click="editParasiteControl(item)">
              mdi-pencil
            </v-icon>
            <v-icon color="red" @click="deleteParasiteControl(item)">
              mdi-delete
            </v-icon>
          </div>
        </template>
        <template v-slot:footer></template>
      </v-data-table>
    </div>
    <ParasiteControlDialog
      @closeDialog="closeDialog"
      v-if="showParasiteControlDialog"
      :dialogI="showParasiteControlDialog"
      :parasiteControlItem="parasiteControlItem"
      @onUpdate="onParasiteControlUpdate"
    />
    <DeletePopup
      :dialogI="showDeleteDialog"
      v-if="showDeleteDialog"
      @delete="onDelete"
      @closeDialog="closeDeleteDialog"
    />
  </v-card>
</template>
<script>
import ColSkeletonLoader from "@/components/col-skeleton-loader.vue";
import generalMixin from "@/mixins/GeneralMixin";
import ParasiteControlDialog from "./ParasiteControlDialog.vue";
import gql from "graphql-tag";
import moment from "moment";
import DeletePopup from "../DeletePopup.vue";

export default {
  components: {
    ColSkeletonLoader,
    ParasiteControlDialog,
    DeletePopup,
  },
  created() {},
  watch: {
    parasiteControl: function () {
      this.loading = false;
    },
  },
  mixins: [generalMixin],
  data() {
    return {
      showParasiteControlDialog: false,
      showDeleteDialog: false,
      currentAnimal: {},
      loading: false,
      parasiteControlData: this.parasiteControl[0],
      parasiteControlItem: {
        id: null,
        doseRate: "",
        doseRateUnit: "",
        animalId: parseInt(this.$route.params.animal_number),
        parasiteDate: "",
        parasiteDrugName: "",
        purpose: "",
        remarks: "",
        routeOfAdministration: "",
        withdrawalPeriod: null,
        withdrawalPeriodUnit: "",
      },
      parasiteControlTableData: this.parasiteControl,
      headers: [
        {
          text: "Treatment Date",
          value: "parasiteDate",
          align: "start" 
        },
        { text: "Purpose", value: "purpose", align: "start"  },
        { text: "Drug Name", value: "parasiteDrugName", align: "start"  },
        { text: "Dose", value: "doseRate", align: "start"  },
        {
          text: "Withdrawal Period",
          value: "withdrawalPeriod",
          align: "start" 
        },
        {
          text: "Route of Administration",
          value: "routeOfAdministration",
          align: "start" 
        },
        { text: "Notes", value: "remarks", align: "start"  },
        { text: "", value: "actions", sort: "false", align: "start"  },
      ],
    };
  },
  mounted() {
    this.parasiteControlData = Object.assign({}, this.parasiteControl[0]);
    this.parasiteControlTableData =
      this.parasiteControl.length !== 0 &&
      this.parasiteControl.filter((x) => x.id !== this.parasiteControl[0].id);
  },
  methods: {
    onParasiteControlUpdate() {
      this.$emit("parasiteContol:updated");
    },
    closeDialog() {
      this.showParasiteControlDialog = false;
      this.parasiteControlItem = null;
    },
    editParasiteControl(item) {
      this.parasiteControlItem = item;
      this.showParasiteControlDialog = true;
    },
    showAddParasiteControlDialog(action) {
      if (action == "edit") {
        this.parasiteControlItem = this.parasiteControlData;
      } else {
        this.parasiteControlItem = null;
      }
      this.showParasiteControlDialog = true;
    },
    closeDeleteDialog() {
      this.showDeleteDialog = false;
      this.parasiteControlItem = null;
    },
    async onDelete() {
      await this.$apollo
        .mutate({
          mutation: gql`
            mutation deleteParasiteControl($data: UpdateParasiteControlInput!) {
              deleteParasiteControl(updateParasiteControl: $data)
            }
          `,
          variables: {
            data: {
              id: this.parasiteControlItem.id,
              animalId: parseInt(this.$route.params.animal_number),
              parasite_date: this.parasiteControlItem.parasiteDate
                ? moment(this.parasiteControlItem.parasiteDate).format(
                    "YYYY-MM-DD"
                  )
                : null,
              purpose: this.parasiteControlItem.purpose,
              parasite_drug_name: this.parasiteControlItem.parasiteDrugName,
              dose_rate: this.parasiteControlItem.doseRate,
              dose_rate_unit: this.parasiteControlItem.doseRateUnit,
              withdrawal_period: parseInt(
                this.parasiteControlItem.withdrawalPeriod
              ),
              withdrawal_period_unit:
                this.parasiteControlItem.withdrawalPeriodUnit,
              route_of_administration:
                this.parasiteControlItem.routeOfAdministration,
              remarks: this.parasiteControlItem.remarks,
            },
          },
        })
        .then(async (response) => {
          this.$notify({
            title: `History deleted successfully`,
            text: response.message,
            type: "success",
            position: "top right",
          });
        });
      this.showDeleteDialog = false;
      this.$emit("parasiteContol:updated");
    },
    deleteParasiteControl(item) {
      this.showDeleteDialog = true;
      this.parasiteControlItem = item;
    },
  },
  props: ["parasiteControl"],
};
</script>
<style scoped>
.title {
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 26px;
  color: #1e1e1e;
}
</style>
